import { createActions } from "../../utils/reduxsauce";

const { Types, Creators } = createActions(
  {
    getAllVisits: { args: ["payload"], meta: { async: true } },
    getVisitWithId: { args: ["payload"], meta: { async: true } },
    showDialog: { args: [], meta: { async: false } },
    resetDialog: { args: [], meta: { async: false } },
  },
  {
    prefix: "@app/visits/",
  },
);
export const ActionTypes = Types;
export default Creators;
